import type { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement>;

function Base({ children, ...props }: IconProps & { children: React.ReactNode }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}>
      {children}
    </svg>
  );
}

export function InstagramIcon(props: IconProps) {
  return (
    <Base {...props}>
      <path d="M12 2c2.72 0 3.06.01 4.12.06 1.06.05 1.79.22 2.42.46.66.26 1.22.6 1.77 1.16.56.55.9 1.11 1.16 1.77.24.63.41 1.36.46 2.42.05 1.06.06 1.4.06 4.13s-.01 3.07-.06 4.13c-.05 1.06-.22 1.79-.46 2.42-.26.66-.6 1.22-1.16 1.77-.55.56-1.11.9-1.77 1.16-.63.24-1.36.41-2.42.46-1.06.05-1.4.06-4.12.06s-3.06-.01-4.12-.06c-1.06-.05-1.79-.22-2.42-.46a4.9 4.9 0 0 1-1.77-1.16 4.9 4.9 0 0 1-1.16-1.77c-.24-.63-.41-1.36-.46-2.42C2.01 15.07 2 14.73 2 12s.01-3.07.06-4.13c.05-1.06.22-1.79.46-2.42.26-.66.6-1.22 1.16-1.77A4.9 4.9 0 0 1 5.45 2.52c.63-.24 1.36-.41 2.42-.46C8.94 2.01 9.28 2 12 2Zm0 1.8c-2.67 0-2.99.01-4.04.06-.81.04-1.25.17-1.54.29-.39.15-.66.33-.95.62-.29.29-.47.56-.62.95-.12.29-.25.73-.29 1.54-.05 1.05-.06 1.37-.06 4.04s.01 2.99.06 4.04c.04.81.17 1.25.29 1.54.15.39.33.66.62.95.29.29.56.47.95.62.29.12.73.25 1.54.29 1.05.05 1.37.06 4.04.06s2.99-.01 4.04-.06c.81-.04 1.25-.17 1.54-.29.39-.15.66-.33.95-.62.29-.29.47-.56.62-.95.12-.29.25-.73.29-1.54.05-1.05.06-1.37.06-4.04s-.01-2.99-.06-4.04c-.04-.81-.17-1.25-.29-1.54a2.55 2.55 0 0 0-.62-.95 2.55 2.55 0 0 0-.95-.62c-.29-.12-.73-.25-1.54-.29-1.05-.05-1.37-.06-4.04-.06Zm0 3.06a5.14 5.14 0 1 1 0 10.28 5.14 5.14 0 0 1 0-10.28Zm0 1.8a3.34 3.34 0 1 0 0 6.68 3.34 3.34 0 0 0 0-6.68Zm5.35-3.15a1.2 1.2 0 1 1 0 2.4 1.2 1.2 0 0 1 0-2.4Z" />
    </Base>
  );
}

export function TikTokIcon(props: IconProps) {
  return (
    <Base {...props}>
      <path d="M16.6 2h-3.1v13.2a2.6 2.6 0 1 1-2.6-2.6c.24 0 .47.03.69.1V9.53a5.8 5.8 0 0 0-.69-.04 5.72 5.72 0 1 0 5.72 5.72V8.2a6.3 6.3 0 0 0 3.72 1.2V6.3a3.5 3.5 0 0 1-2.5-1.04A3.5 3.5 0 0 1 16.6 2.8V2Z" />
    </Base>
  );
}

export function YouTubeIcon(props: IconProps) {
  return (
    <Base {...props}>
      <path d="M21.6 7.2a2.5 2.5 0 0 0-1.76-1.77C18.28 5 12 5 12 5s-6.28 0-7.84.43A2.5 2.5 0 0 0 2.4 7.2C2 8.77 2 12 2 12s0 3.23.4 4.8a2.5 2.5 0 0 0 1.76 1.77C5.72 19 12 19 12 19s6.28 0 7.84-.43a2.5 2.5 0 0 0 1.76-1.77C22 15.23 22 12 22 12s0-3.23-.4-4.8ZM10 15.2V8.8l5.2 3.2-5.2 3.2Z" />
    </Base>
  );
}

export function FacebookIcon(props: IconProps) {
  return (
    <Base {...props}>
      <path d="M13.5 22v-8h2.7l.4-3.1h-3.1V8.9c0-.9.25-1.5 1.53-1.5h1.64V4.6c-.28-.04-1.27-.12-2.42-.12-2.4 0-4.05 1.46-4.05 4.16v2.26H7.5V14h2.7v8h3.3Z" />
    </Base>
  );
}

export function LinkedInIcon(props: IconProps) {
  return (
    <Base {...props}>
      <path d="M6.94 4.5a2.06 2.06 0 1 1-4.12 0 2.06 2.06 0 0 1 4.12 0ZM3.1 20.5h3.6V8.9H3.1v11.6Zm6.1-11.6h3.45v1.6h.05c.48-.9 1.66-1.85 3.42-1.85 3.66 0 4.33 2.28 4.33 5.25v6.6h-3.6v-5.85c0-1.4-.25-2.85-1.9-2.85-1.6 0-1.85 1.25-1.85 2.75v5.95H9.2V8.9Z" />
    </Base>
  );
}

export function TelegramIcon(props: IconProps) {
  return (
    <Base {...props}>
      <path d="M21.6 4.3 18.9 19c-.2 1.1-.86 1.36-1.74.85l-4.8-3.54-2.32 2.23c-.26.26-.47.47-.96.47l.35-4.9 9.04-8.17c.4-.35-.08-.54-.6-.2L6.7 12.78l-4.79-1.5c-1.04-.33-1.06-1.04.22-1.54l18.05-6.96c.87-.32 1.63.2 1.42 1.52Z" />
    </Base>
  );
}

export const socialIcons = {
  telegram: TelegramIcon,
  instagram: InstagramIcon,
  facebook: FacebookIcon,
  linkedin: LinkedInIcon,
} as const;